import { apiHelper, getApiBaseUrl } from '../utils/apiHelper';

const API_URL = `${getApiBaseUrl()}/api/org`;

// const headers = {
//   "Content-Type": "multipart/form-data",
//   "Accept": "application/json"
// };

export const fetchOrganizationDetails = (payload) => apiHelper(`${API_URL}/organization-details`, 'GET', payload);
